<template>
  <el-dialog class="batchDialog" :visible.sync="visible" width="1000px" :title="title" @close="closeHandle">
    <EditPrice ref="editPriceRef" :type="type" :platformType="opts.platformType" />
    <span slot="footer" class="dialog-footer">
      <el-button :loading="requestLoading" @click="closeHandle">取 消</el-button>
      <el-button type="primary" :loading="requestLoading" @click="handleOK">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
import EditPrice from '../../BasicComps/EditPrice.vue';
import { getControllerPriceListByCustom } from '@/api/prod/center';

export default {
  components: {
    EditPrice,
  },
  data() {
    return {
      visible: false,
      opts: {},
      type: 'sales',
      requestLoading: false,
      title: '批量修改价格',
    };
  },
  methods: {
    method_open(opts) {
      const { type } = opts;
      this.opts = opts;
      this.visible = true;
      this.type = type || 'sales';
    },
    formatFormulaValue(formulaValue) {
      const { priceMultiplier, addValue, subtractionValue, centDime, percentage } = formulaValue;
      Object.assign(formulaValue, {
        priceMultiplier,
        addValue: addValue || 0,
        subtractionValue: subtractionValue || 0,
        centDime: centDime || 0,
        percentage: percentage || 0,
      });
      return formulaValue;
    },
    handleOK() {
      if (!this.$refs.editPriceRef.validate()) return false;
      this.handleSubmit();
    },
    async handleSubmit() {
      const formData = this.$refs.editPriceRef.getFormData();
      const type = this.type;
      let { baseItemId, platformType, shopId, activeName, shopIds } = this.opts || {};
      if (platformType === 'alibaba') {
        platformType = 'a1688';
      }
      const { inputValue, formulaValue, way } = formData;
      const requestParams = {
        itemId: baseItemId,
        platformType,
        common: activeName === 'shops' ? 0 : 1,
        priceConfInfo: {
          type,
          way,
          incr: 0,
          formulaValue: this.formatFormulaValue(formulaValue),
        },
      };
      if (activeName === 'shops') {
        requestParams.shopIds = [shopId];
      } else if (platformType === 'tm') {
        requestParams.shopIds = shopIds;
      }
      if (way === 'unity') {
        this.opts.okFn && this.opts.okFn(way, inputValue);
        this.closeHandle();
      } else {
        const res = await getControllerPriceListByCustom(requestParams);
        this.opts.okFn && this.opts.okFn(way, res.data);
        this.closeHandle();
      }
    },
    closeHandle() {
      this.visible = false;
    },
  },
};
</script>

<style lang="scss" scoped>
</style>